import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDocuments } from "../../redux/actions/actionDocument";
import AprobacionPreOrdenCard from "./aprobacionPreordenCard";
import { SALDADO, NO_SALDADO, SIETE_SEND, SIETE_OUT, SIETE_ALL } from "../../Constantes/constantesFiltros";

export default function AprobacionPreOrden() {
    const dispatch = useDispatch()
    const documents = useSelector(state => state.documents.allDocuments)
    //const documentsNoAprobados = useSelector(state => state.documents.allNoAprobados)

    useEffect(() => {
        dispatch(getDocuments())        
    }, [dispatch])

    console.log(documents)
    //console.log(documentsNoAprobados)
    const noApproved = documents[0] === undefined ? console.log("No documentos") : documents[0].filter(e=> e.approved === false)
    console.log(noApproved)




    return (
        <div className="container m-5 border-black border-2">
            <div>
                <p className="text-xl pb-8 underline">Aprobacion de Pedidos</p>
            </div>

            {/* <div className="flex flex-row h-20 bg-cyan-700 border-2 border-black">
                <div className="w-42 border-2 border-gray-100 h-11">
                    <FilterSeven />
                </div>
                <div className="flex flex-col w-40 text-[12px] font-bold bg-slate-200">
                    <label>Estado Documento</label>
                    <div className="flex flex-row w-40">
                        <p className="w-20">Saldados</p>
                        <div>
                            <input
                                type="checkbox"
                                checked={checkSal}
                                value={SALDADO}
                                onChange={handleCheckSaldado}
                            />
                        </div>
                    </div>
                    <div className="flex flex-row w-40">
                        <p className="w-20">No Saldados</p>
                        <div>
                            <input
                                type="checkbox"
                                checked={checkNoSal}
                                value={NO_SALDADO}
                                onChange={handleCheckNoSaldado}
                            />
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="flex flex-row">
                <div className="text-[14px] font-bold text-center w-12">Doc N°</div>
                <div className="text-[14px] font-bold text-left pl-2 w-60">Cliente</div>
                <div className="text-[14px] font-bold text-left pl-2 w-80">Domicilio Evento</div>
                <div className="text-[14px] font-bold text-center w-20">Fecha de Salida</div>
                <div className="text-[14px] font-bold text-center w-20">Fecha de Entrada</div>
                <div className="text-[14px] font-bold text-center w-20">Aprobar</div>
                <div className="text-[14px] font-bold text-center w-20">-</div>
            </div>

            <div>
                {noApproved !== undefined ? noApproved.map(e=>
                <AprobacionPreOrdenCard 
                    key={e._id}
                    id={e._id}
                    addressEvent={e.addressEvent}
                    name_client={e.client_id.name}
                    dateReception={e.dateReception}
                    dateSend={e.dateSend}                    
                    numberDocument={e.numberDocument}
                    state={e.state}
                    
                />
                ) : null}
            </div>
        </div>
    )
}